<div class="flex flex-col flex-1 w-full h-full">
  <mat-expansion-panel
    class="w-full cursor-default"
    [expanded]="isExpandedByDefault"
    [disabled]="!isExpandable"
    (opened)="onOpen($event)"
    (closed)="onClose($event)"
    data-testid="sectionHeader"
  >
    <mat-expansion-panel-header
      class="bg-project-600"
      [ngClass]="{
        'hover:cursor-default': !isExpandable,
        'hover:contrast-[1.05]': isExpandable
      }"
      data-testid="header"
      [collapsedHeight]="HEADER_HEIGHT"
      [expandedHeight]="HEADER_HEIGHT"
    >
      <mat-panel-title class="flex space-x-3 text-project-2400">
        <ng-container *ngIf="!headerRef.hasChildNodes()">
          <i class="text-inherit icon" [ngClass]="iconClass"></i>
          <h3 class="text-sm text-inherit whitespace-nowrap">{{ title }}</h3>
          <mat-form-field
            class="w-16"
            appearance="outline"
            [floatLabel]="'never'"
            title="Section Number"
          >
            <input
              matInput
              min="1"
              max="100"
              type="number"
              class="absolute w-full h-full -inset-0.5"
              [formControl]="form.controls.order"
              (keydown)="handleInput($event)"
              (click)="handleInput($event)"
              data-testid="sectionNumber"
            />
          </mat-form-field>
          <p *ngIf="form.controls.name.value" class="w-56 text-xs break-words" data-testid="sectionNameTitle">
            {{ form.controls.name.value }}
          </p>
          <div class="flex flex-1"></div>
          <p
            *ngIf="!isDisabled"
            class="flex justify-end text-xs font-semibold min-w-max hover:text-project-500 hover:underline"
            data-testid="removebtn"
            (click)="removeSection($event)"
          >
            Remove section
          </p>
        </ng-container>

        <div
          [ngClass]="{ hidden: !headerRef.hasChildNodes() }"
          class="flex w-full h-11"
          #headerRef
        >
          <ng-content select="[header]"> </ng-content>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="flex-col flex-1" [ngClass]="" data-testid="expandedContent">
      <ng-content select="[expandedContent]"> </ng-content>
      <div class="flex flex-col flex-1 w-full pt-3">
        <app-text-input
          [maxLength]="maxNameLength"
          [control]="this.form.controls.name"
          placeholder="Section Name"
          data-testid="sectionName"
        ></app-text-input>
        <p class="px-2 pt-2 text-xs" data-testid="urlPathDisplay">
          {{ urlPath }}/{{ this.form.controls.path.value }}
        </p>
        <app-text-input
          [control]="this.form.controls.path"
          placeholder="Url Path"
          data-testid="sectionUrlPath"
        ></app-text-input>
        <div
          *ngIf="this.form.controls.path.hasError('duplicate')"
          class="p-2 mx-0.5 text-xs bg-red-300/50 outline outline-1 outline-red-400"
        >
          Url Paths for sections must be unique
        </div>
        <app-related-data
          class="py-2"
          [isExpandable]="!isDisabled"
          [isExpandedByDefault]="false"
          [managerListControl]="form.controls.relatedManagers"
          [fundListControl]="form.controls.relatedFunds"
          [sectorListControl]="form.controls.relatedSectors"
          [assetClassListControl]="form.controls.relatedAssetClasses"
          [investmentTrustListControl]="form.controls.relatedInvestmentTrusts"
          [shareListControl]="form.controls.relatedShares"
        ></app-related-data>
        <app-tagging
          class="py-2"
          [topicControl]="form.controls.topics"
          [tagControl]="form.controls.tags"
          [companyControl]="form.controls.relatedCompanies"
          [peopleControl]="form.controls.relatedPeoples"
          [websites]="[]"
          [isExpandedByDefault]="false"
          [isExpandable]="!isDisabled"
        >
        </app-tagging>
      </div>
    </div>
  </mat-expansion-panel>
</div>
